import React from "react";
import Grid from "@mui/material/Grid";

import SingleImageBox from "components/common/singleImageBox";
import InfoBox from "components/common/infoBox";
import InfoBoxMain from "components/common/infoBoxMain";
import futurecareMain from "assets/images/futurecare-main.png";
import futurecareLogo from "assets/images/futurecare-logo.png";
import DoubleImageBox from "components/common/doubleImageBox";
import futurecareA from "assets/images/futurecare-a.png";
import futurecareB from "assets/images/futurecare-b.png";
import futurecareC from "assets/images/futurecare-c.png";
import futurecareD from "assets/images/futurecare-d.png";
import { useTranslation } from "react-i18next";
const FutureCare = () => {
  const { t } = useTranslation();
  return (
    <Grid container>
      <Grid
        item
        md={6}
        xs={12}
        marginTop={10}
        marginBottom={10}
        className="left-align padding-left-col">
        <InfoBoxMain
          imgSrc={futurecareLogo}
          width="270px"
          heading={t("futurecare-card-1.heading")}
          infoText={t("futurecare-card-1.infoText")}
          linkText={t("futurecare-card-1.linkText")}
          route="/digitalsolution"
        />
      </Grid>
      <Grid
        item
        md={6}
        xs={12}
        marginTop={10}
        marginBottom={10}
        className="center-align padding-right-col">
        <SingleImageBox imgSrc={futurecareMain} width="40rem"></SingleImageBox>
      </Grid>
      <Grid item md={6} xs={12} className="bg-light1 center-align padding-left-col">
        <DoubleImageBox imgSrc={futurecareA} />
      </Grid>
      <Grid item md={6} xs={12} className="bg-light1 left-align padding-righ-col">
        <InfoBox
          headingText={t("futurecare-card-2.headingText")}
          infoText={t("futurecare-card-2.infoText")}
        />
      </Grid>
      <Grid item md={6} xs={12} className=" left-align padding-left-col">
        <InfoBox
          headingText={t("futurecare-card-3.headingText")}
          infoText={t("futurecare-card-3.infoText")}
        />
      </Grid>
      <Grid item md={6} xs={12} className=" center-align padding-righ-col">
        <DoubleImageBox imgSrc={futurecareB} />
      </Grid>
      <Grid item md={6} xs={12} className="bg-light1 center-align padding-left-col">
        <DoubleImageBox imgSrc={futurecareC} />
      </Grid>
      <Grid item md={6} xs={12} className="bg-light1 left-align padding-righ-col">
        <InfoBox
          headingText={t("futurecare-card-4.headingText")}
          infoText={t("futurecare-card-4.infoText")}
        />
      </Grid>
      <Grid item md={6} xs={12} marginTop={10} className=" left-align padding-left-col ">
        <InfoBox
          headingText={t("futurecare-card-5.headingText")}
          infoText={t("futurecare-card-5.infoText")}
        />
      </Grid>
      <Grid item md={6} xs={12} marginTop={10} className=" center-align padding-righ-col">
        <DoubleImageBox imgSrc={futurecareD} />
      </Grid>
      <Grid item xs={12} sx={{ height: "210px" }}></Grid>
    </Grid>
  );
};

export default FutureCare;
